import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { MiniPill } from '../../../ui/MiniPill/MiniPill.jsx'
import { IconButton } from '../../../ui'

/**
 * DecisionsCard — session-decisions (catalog #2, CORE).
 *
 * Co-edited list. agreed-by tag auto-stamped server-side on write.
 * Immutable on session-complete (SESSION_LOCKED from backend).
 *
 * Phase F: typed Decision rows from the backend.
 */

export function DecisionsCard({
  decisions = [],
  onAdd,
  onUpdate,
  onRemove,
  disabled = false,
}) {
  const hasItems = decisions.length > 0

  function handleAdd() {
    onAdd?.({ text: '' })
  }

  return (
    <CardFrame
      kind="session"
      icon="⬡"
      iconClass="berry"
      title="Decisions made"
      prompt="What did you agree on?"
      state={disabled ? 'locked' : hasItems ? 'filled' : 'empty'}
      data-testid="session-card-decisions"
      className="session-card"
    >
      {hasItems ? (
        <div className="decision-list">
          {decisions.map((dec) => (
            <div key={dec.decisionId} className="decision-list__row">
              <MiniPill kind="decision" aria-label="Decision">decision</MiniPill>
              <input
                className="decision-list__input"
                value={dec.text}
                disabled={disabled}
                placeholder={disabled ? '' : 'What was decided…'}
                onChange={(e) => onUpdate?.(dec.decisionId, { text: e.target.value })}
                aria-label={`Decision: ${dec.text || 'empty'}`}
              />
              {dec.agreedBy && (
                <MiniPill kind="agreed" aria-label="Agreed">agreed</MiniPill>
              )}
              {!disabled && (
                <IconButton
                  ariaLabel="Remove decision"
                  onClick={() => onRemove?.(dec.decisionId)}
                  tabIndex={-1}
                >×</IconButton>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="session-card__empty">No decisions yet.</p>
      )}

      {!disabled && (
        <button type="button" className="session-card__add-btn" onClick={handleAdd}>
          + add decision
        </button>
      )}
    </CardFrame>
  )
}
